import React, { useRef } from 'react';
import Button from '@mui/material/Button';
import moment from 'moment';
import PrintIcon from '@mui/icons-material/Print';
import { printToKOTPrinter } from './PrintUtility';
import './Print.scss';
import { getRoomLabelText, formatPrintAmount } from '@src/utilities/common';
import {
  ORDER_SERVICE_TYPE_LABELS,
  normalizeOrderServiceType,
  type OrderServiceType,
} from '@constants/orderServiceType';

// import { getGstData } from '../Cart';
// import { stringify } from 'querystring';

declare global {
    interface Window {
        ReactNativeWebView: any;
    }
}

interface componentRef {
    current: any
}

export const getResutarantBillHTMLString = (item: any, restaurant: any) => {
    var sum = "";
    const serviceType: OrderServiceType = normalizeOrderServiceType(item?.serviceType);
    const serviceLabel = ORDER_SERVICE_TYPE_LABELS[serviceType];
    const tableLabel = serviceType === 'takeaway' ? 'Pickup Ref:' : 'Table No:';
    // var logo = await toDataURL(restaurant?.logo || SampleImage);
    var logo = restaurant?.logo;
    var sign = restaurant?.managerSignFoodBill;
    !!(item?.cart) && Object.entries(item?.cart).filter(([_keyCart, itemCart]: any) => !!itemCart?.name).forEach(([_keyCart2, itemCart]: any) => {
        sum += `<tr>
            <td style="text-align: left;">
                ${(itemCart?.name)?.replaceAll("-", " ")} (${(itemCart?.selectedVariants?.label)?.replaceAll('₹', '')})
            </td>
            <td style="width: 30px; text-align: right;">
                x ${itemCart?.selected}
            </td>
            <td style="width: 30px; text-align: right;">
                ${itemCart?.selectedVariants?.value * itemCart?.selected}
            </td>
        </tr>`;
    });
    sum?.replaceAll('undefined', '');
    return `
         <style>
            p {margin: 0; font-size: 14px; font-family: system-ui;} b {font-weight: 600;}
        </style>
        <div style="font-size: 10px; width: 190px; color: #000;">
            ${(!!logo && `<p style="font-size: 13px; text-align: center; font-weight: bold;">
                 <img width="150px" src=${logo} title="manager sign" />
            </p>`)  || ''}
            <p style="font-size: 14px; text-align: center; font-weight: bold; margin: 0;">${item?.restaurant?.name}</p>

            <p style="font-size: 10px; text-align: center; margin-top: 10px;font-size: 9px;">${item?.restaurant?.address}</p>
            
            ${(!!restaurant.email && `<p style="text-align: center; margin-top: 5px; font-size: 9px;">Email: ${restaurant.email}</p>`) || ""}
            ${(!!restaurant.phone && `<p style="text-align: center; margin-top: 3px;font-size: 9px;">Phone: ${restaurant.phone}</p>`) || ""}
            ${(!!item?.isGstBill && `<p style="text-align: center;margin-top: 3px;font-size: 9px;">GSTIN: ${restaurant?.gstIn}</p>`) || ""}
            ${(!!restaurant.fssai && `<p style="text-align: center; margin-top: 3px;font-size: 9px;">FSSAI NO: ${restaurant.fssai}</p>`) || ""}

            <p style="text-align: center;margin-top: 10px; position: relative; font-size: 12px; font-weight: 500">
                <span style="position: absolute; border-bottom: 1px solid #ddd; width: 100%; top: 50%; left: 0;"></span>
                <span style="background: #fff;z-index: 5;position: relative;padding: 0 5px;">Tax Invoice</span>
            </p>

            <table style="font-size: 10px; width: 190px; text-transform: capitalize; padding-top: 10px;vertical-align: baseline;">
                <tr>
                    <td width="80px" style="vertical-align: baseline;">
                        Invoice No:
                    </td>
                    <td style="text-align: right; vertical-align: baseline;">
                        ${item?.orderSeqNo || item?.uoId || item?.orderId}
                    </td>
                </tr>
                <tr>
                    <td width="80px" style="vertical-align: baseline;">
                        Invoice Date:
                    </td>
                    <td style="text-align: right; vertical-align: baseline;text-transform: lowercase;">
                        ${moment(item?.createdAt).local().format('DD MMM, YYYY hh:mm a')}
                    </td>
                </tr>
                <tr>
                    <td width="80px" style="vertical-align: baseline;">
                        Order Type:
                    </td>
                    <td style="text-align: right; vertical-align: baseline;text-transform: capitalize;">
                        ${serviceLabel}
                    </td>
                </tr>
                <tr>
                    <td width="80px" style="vertical-align: baseline;">
                        ${tableLabel}
                    </td>
                    <td style="text-align: right; vertical-align: baseline;text-transform: lowercase;">
                        ${item?.tableDisplay || getRoomLabelText(item?.tableNumber?.split("-")[0], parseInt(item?.tableNumber?.split("-")[1]))}
                    </td>
                </tr>
            </table>
            ${(!!item?.billingName &&
            `<p style="text-align: center;margin-top: 10px; position: relative; font-size: 12px; font-weight: 500">
                <span style="position: absolute; border-bottom: 1px solid #ddd; width: 100%; top: 50%; left: 0;"></span>
                <span style="background: #fff;z-index: 5;position: relative;padding: 0 5px;">Guest Details</span>
            </p>`) || ''}
            <table style="font-size: 10px; width: 190px; text-transform: capitalize; padding-top: 10px;vertical-align: baseline;">
                ${(!!item?.billingName &&
        `<tr>
                    <td style="vertical-align: baseline;">
                        Guest Name:
                    </td>
                    <td style="text-align: right;vertical-align: baseline;">
                        ${item?.billingName}
                    </td>
                </tr>`) || ''
        }
                ${(!!item?.gstNumber &&
        `<tr>
                        <td style="vertical-align: baseline;">
                            Guest GSTIN:
                        </td>
                        <td style="text-align: right;vertical-align: baseline;">
                            ${item?.gstNumber}
                        </td>
                    </tr>`)  || ''
        }
         ${(!!item?.billingAddress &&
        `<tr>
                        <td style="vertical-align: baseline;">
                            Guest Address:
                        </td>
                        <td style="text-align: right;vertical-align: baseline;">
                            ${item?.billingAddress}
                        </td>
                    </tr>`)  || ''
        }
                ${(!!item?.customerPhone &&
        `<tr>
                    <td style="vertical-align: baseline;">
                        Guest Phone No:
                    </td>
                    <td style="text-align: right;vertical-align: baseline;">
                        ${item?.customerPhone}
                    </td>
                </tr>`)  || ''
        }
            </table>

            <table style="font-size: 10px; width: 190px; border-top: 1px solid #ddd; text-transform: capitalize; margin-top: 10px; padding-top: 10px;">
                <thead>
                    <td style="text-align: left; font-weight: 600;">ITEM</td>
                    <td style="text-align: right; font-weight: 600;">QTY</td>
                    <td style="text-align: right; font-weight: 600;">COST</td>
                </thead>
                ${sum || ''}
            </table>
            <table style="font-size: 11px; width: 190px;  border-top: 1px solid #ddd; margin-top: 10px; padding-top: 10px;">
                <tr>
                    <td style="text-align: right; padding-bottom: 2px;">Items Cost:</td>
                    <td style="width: 65px; text-align: right;">Rs.${formatPrintAmount(item?.itemsCost)}</td>
                </tr>

                ${(!!item?.isGstBill && !!item?.gstData && Object.entries(item?.gstData).filter(([_, val]) => !!val).map(([key, val]) => {
                    const gstRate = formatPrintAmount(Number(key) / 2);
                    const gstAmount = formatPrintAmount(Number(val) / 2);
                    return (
                    `<tr key="${key}">
                        <td style="text-align: right;padding-bottom: 2px;">CGST(@${gstRate}%) :</td>
                        <td style="width: 65px; text-align: right;">Rs.${gstAmount}</td>
                    </tr>
                    <tr key="${key}">
                        <td style="text-align: right;padding-bottom: 2px;">SGST(@${gstRate}%) :</td>
                        <td style="width: 65px; text-align: right;">Rs.${gstAmount}</td>
                    </tr>`
                    );
                }).join('')) || ''}

                ${(!!item?.discount && `<tr>
                    <td style="text-align: right;padding-bottom: 2px;">Discount:</td>
                    <td style="width: 65px; text-align: right;">Rs.${formatPrintAmount(item?.discount)}</td>
                </tr>`) || ''}
                <tr>
                    <td style="font-weight: bold; text-align: right;padding-top: 4px;">Total Bill:</td>
                    <td style="font-weight: bold; width: 65px; text-align: right;">Rs.${formatPrintAmount(item?.totalCost)}</td>
                </tr>
            </table>
            ${(!!sign && `<table style="font-size: 10px; margin-top: 15px; border-top: 1px solid #ddd; padding-top: 15px; width: 190px;">
                    <tr>
                            <td>
                                <p style="text-align: right">
                                    <img width="150" src=${sign} title="manager sign" />
                                </p>
                            </td>
                        </tr>
                                                <tr>
                                                    <td>
                                                        <p style="font-size: 10px;text-align: right"><b>Authorized Signatory</b></p>
                                                        <p style="font-size: 10px;text-align: right; margin-top: 4px;">Digitally Signed by ${item?.restaurant?.name}</p>
                                                        <p style="font-size: 10px;text-align: right; margin: 0;">${moment(item?.createdAt).local().format('DD MMM, YYYY h:mm a')}</p>
                                                    </td>
                                                </tr>
            </table>`) || ''}
            <p style="font-size: 12px;text-align: center; margin-top: 10px; padding-top: 10px; border-top: 1px solid #ddd;">Thank you for your visit :)</p>
        </div>
    `;
}

/** Print tax invoice for a saved food order (same as Orders list Print button). */
export async function printFoodOrderBill(order: any, restaurant: any): Promise<void> {
    if (!order?.cart || !Object.values(order.cart).some((line: any) => line?.name && line?.selected > 0)) {
        throw new Error('Nothing to print');
    }
    const htmlContent = await getResutarantBillHTMLString(order, restaurant);
    await printToKOTPrinter('main', htmlContent, order?.uoId || order?.orderId);
}

function Print({ item, restaurant }: any) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- used in doc.html() and ref
    const componentRef: componentRef = useRef(null);
    // Create a root reference
    // const firebaseApp = getApp();
    // const storage = getStorage(firebaseApp, "gs://iit-nirvana.appspot.com");
    // const storageRef = ref(storage, `order-pdf/${item?.orderId}.pdf` || 'order-pdf/order-pdf.pdf');

    // const handlePrint = useReactToPrint({
    //     content: () => componentRef?.current,
    // });

    // const sendMessageToWebView = (urlPdf: any) => {
    //     const data = {"type": "print", "data": urlPdf || "https://www.adobe.com/support/products/enterprise/knowledgecenter/media/c4611_sample_explain.pdf"};
    //     // console.log(data, componentRef?.current?.innerHTML);
    //     if(window?.ReactNativeWebView){
    //         // const data = 'Hello from React!';
    //         window.ReactNativeWebView.postMessage(JSON.stringify(data) || "");
    //     } else {
    //         handlePrint();
    //     }
    // };

    /*
    const uploadToCloud = () => {
        // Create a reference to the file we want to download
        // const storage = getStorage();
        // const starsRef = ref(storage, 'images/stars.jpg');

        // Get the download URL
        getDownloadURL(storageRef)
            .then((url) => {
                // Insert url into an <img> tag to "download"
                sendMessageToWebView(url);
            })
            .catch((error) => {
                // A full list of error codes is available at
                // https://firebase.google.com/docs/storage/web/handle-errors
                switch (error.code) {
                    case 'storage/object-not-found':
                        // File doesn't exist
                        const doc = new jsPDF({
                            format: 'a5',
                            unit: 'px',
                        });
                        // Adding the fonts.
                        doc.setFont('Inter-Regular', 'normal');
                        // doc.set
                        doc.html(componentRef?.current, {
                            async callback(doc) {
                                // console.log('---doc--main', doc);
                                // await doc.save(item?.orderId || 'document');
                                // handleUpload(doc);
                                const blobPDF = new Blob([doc.output('blob')], {type: 'application/pdf'});
                                // const blobURL = URL.createObjectURL(blobPDF);
                                // 'file' comes from the Blob or File API
                                uploadBytes(storageRef, blobPDF).then((snapshot: any) => {
                                    console.log('Uploaded a blob or file!', snapshot);
                                }).finally(()=> {
                                    // Get the download URL
                                    getDownloadURL(storageRef)
                                        .then((urlS) => {
                                            // Insert url into an <img> tag to "download"
                                            sendMessageToWebView(urlS);
                                        })
                                });
                            },
                        });
                        break;
                    case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;
                    case 'storage/canceled':
                        // User canceled the upload
                        break;
                    // ...
                    case 'storage/unknown':
                        // Unknown error occurred, inspect the server response
                        break;
                }
            });
    }; TODO: Uncomment this when adding share PDF functionality */

    // const printOnNative = (item: any) => {
    //     const htmlString = getHTMLString(item);
    //     sendMessageToWebView(htmlString);
    // }

    const handleGeneratePdf = async (e: any) => {
        e.stopPropagation();
        // if(window?.ReactNativeWebView){
        //     printOnNative(item);
        // } else {
        //     handlePrint();
        // }
        await printFoodOrderBill(item, restaurant);
    };

    return (
        <>
            <Button color='secondary' className='printBtn' onClick={(e: any) => handleGeneratePdf(e)}><PrintIcon /> Print</Button>
        </>
    );
}

export default Print;
